"use strict";
import ms from "ms";
import { TransactionStatus } from "data/graphql/uniswap-data-api/__generated__/types-and-hooks";
const STALE_PENDING_THRESHOLD_MS = ms(`6h`);
export const migration24 = (state) => {
  if (!state?.localWebTransactions) {
    return state;
  }
  const now = Date.now();
  const localWebTransactions = {};
  for (const chainId of Object.keys(state.localWebTransactions)) {
    const chainIdNumber = Number(chainId);
    const transactionsForChain = state.localWebTransactions[chainIdNumber];
    if (!transactionsForChain) {
      continue;
    }
    const retained = {};
    for (const hash of Object.keys(transactionsForChain)) {
      const tx = transactionsForChain[hash];
      const isStalePending = tx.status === TransactionStatus.Pending && tx.addedTime + STALE_PENDING_THRESHOLD_MS < now;
      if (!isStalePending) {
        retained[hash] = tx;
      }
    }
    localWebTransactions[chainIdNumber] = retained;
  }
  return { ...state, localWebTransactions, _persist: { ...state._persist, version: 24 } };
};
